import React from 'react';
import {connect} from 'react-redux';
import MPPScorers from '../MPPScorers';
import MPPSelections from '../MPPSelections';
import MPPUpdateQuotations from './MPPUpdateQuotations';

const MPPDashboardTools = () => (
  <div id="league-MPP">
    <header className="content-header">
      <h1>
        International
        <small>MPP</small>
      </h1>
      <ol className="breadcrumb">
        <li>
          <i className="fa fa-trophy" /> MPP
        </li>
      </ol>
    </header>
    <MPPUpdateQuotations />
    <section className="content">
      <div className="row">
        <div className="col-md-6">
          <MPPScorers />
        </div>
        <div className="col-md-6">
          <MPPSelections />
        </div>
      </div>
    </section>
  </div>
);

export default connect(
  state => ({}),
  dispatch => ({dispatch}),
)(MPPDashboardTools);



// WEBPACK FOOTER //
// ./src/pages/Other/MPP/DashboardTools/index.js